module.exports = __webpack_public_path__ + "img/asset15x1.61d59949.png";